import posthog from 'posthog-js'

// Errors-only, cookieless. Gated to production so local dev stays silent and
// a missing key is a safe no-op. No analytics, no pageviews, no replay.
if (
    process.env.NODE_ENV === 'production' &&
    process.env.NEXT_PUBLIC_POSTHOG_KEY
) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: '/ingest',
        ui_host: 'https://eu.posthog.com',
        capture_exceptions: true,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        disable_session_recording: true,
        persistence: 'memory',
        person_profiles: 'identified_only',
    })
}
